module.exports = __webpack_public_path__ + "static/media/heavywind.d5e30b5b.png";